import { styled, alpha } from '@mui/material/styles'
import { InputBase, Avatar, IconButton } from '@mui/material'
import { colorPalette } from '../../style/colorPalette'

export const ChatHistoryArea = styled('div')({
  flexGrow: 1,
  overflowY: 'auto',
  padding: 16,
  backgroundColor: 'transparent',
})

export const ChatInput = styled(InputBase)({
  backgroundColor: colorPalette.monotone[0],
  borderRadius: 4,
  padding: '8px 12px',
  border: `1px solid ${colorPalette.monotone[2]}`,
  '&:hover': {
    borderColor: colorPalette.monotone[4],
  },
  '&.Mui-focused': {
    borderColor: colorPalette.skyBlue[7],
    boxShadow: `0 0 0 2px ${alpha(colorPalette.skyBlue[7], 0.2)}`,
  },
})

export const MessageContainer = styled('div')<{ isUser: boolean }>(
  ({ isUser }) => ({
    display: 'flex',
    justifyContent: isUser ? 'flex-end' : 'flex-start',
    alignItems: 'flex-start',
    marginBottom: 8,
  })
)

export const MessageBubble = styled('div')<{ isUser: boolean }>(
  ({ isUser }) => ({
    backgroundColor: isUser
      ? colorPalette.skyBlue[1]
      : colorPalette.monotone[1],
    borderRadius: 12,
    padding: '8px 12px',
    maxWidth: '80%',
    marginLeft: isUser ? 0 : 8,
    marginRight: isUser ? 8 : 0,
    whiteSpace: 'pre-wrap',
  })
)

export const AiAvatar = styled(Avatar)({
  backgroundColor: colorPalette.skyBlue[7],
  width: 32,
  height: 32,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const LoadingBubble = styled('div')({
  display: 'inline-block',
  width: '20px',
  height: '20px',
  border: `2px solid ${colorPalette.monotone[2]}`,
  borderTop: `2px solid ${colorPalette.skyBlue[7]}`,
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
  '@keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
  },
})

export const LoadingMessageContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
})

export const PopperHeader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingBottom: 8,
  borderBottom: `1px solid ${colorPalette.monotone[2]}`,
})

export const HeaderTitle = styled('span')({
  fontWeight: 600,
  fontSize: 14,
  color: colorPalette.monotone[10],
})

export const InputArea = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
})

export const SendButton = styled(IconButton)({
  color: colorPalette.skyBlue[7],
  '&.Mui-disabled': {
    color: colorPalette.monotone[3],
  },
})

export const RefreshButton = styled(IconButton)({
  color: colorPalette.monotone[4],
  '&:hover': {
    color: colorPalette.monotone[6],
  },
  '&.Mui-disabled': {
    color: colorPalette.monotone[3],
  },
})
